import { useState, React } from 'external/react';
import {
  Menu,
  MenuItem,
  MoreVertIcon,
  IconButton
} from 'external/material'
import { MenuOptions, CanDoAction } from './ItemAccordion'


type Action = {
  [key in MenuOptions]?: (option: MenuOptions) => void;
}
interface DotMenuProps {
  actions?: Action
  options?: MenuOptions[];
  canDoActions?: CanDoAction
}

const DotMenu: React.FC<DotMenuProps> = ({ actions, options, canDoActions }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (option?: MenuOptions) => {
    setAnchorEl(null);
    const action = actions?.[option as MenuOptions];
    if (option && action && canDoActions?.[option]) {
      action(option);
    }
  };

  return (
    <>
      <IconButton
        aria-label="opciones"
        style={{ padding: 0 }}
        onClick={(e) => {
          e.stopPropagation();
          handleClick(e)
        }}
        aria-controls={open ? 'dot-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="dot-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose()}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        {options?.map((option) => (
          <MenuItem key={option} disabled={canDoActions ? !canDoActions[option] : true} onClick={(e) => {
            e.stopPropagation();
            handleClose(option)
          }}>
            {option}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default DotMenu;
